export const SchoolPlans = {
  LEGACY_MARKETPLACE: "legacy-marketplace",
  LEGACY_WIDGET: "legacy-widget",
  FREE: "free",
  LITE: "lite",
  STANDARD: "standard",
  GROWTH: "growth",
  ENTERPRISE: "pro"
};
